import type { ApplicationsFacetsQuery } from '../AppPageBlock.hirer.generated';

export type ApplicationStatusFacets = {
  inboxCount: number | null;
  prescreenCount: number | null;
  shortlistCount: number | null;
  interviewCount: number | null;
  offerCount: number | null;
  acceptCount: number | null;
  rejectedCount: number | null;
  newCount: number | null;
  totalCount: number | null;
};

/**
 * getStatusFacetsFromQueryData
 * @description Utility function to get status facets from the query data.
 * If there is no application facets data or if the data is not of type `ApplicationsFacetsResponseSuccess`,:
 * - the `applicationFacetsResult` is loading
 * - the `applicationFacetsResult` has errors
 * the function returns `NULL_STATUS_FACETS`.
 */

export const getStatusFacetsFromQueryData = (
  applicationFacetsData: ApplicationsFacetsQuery | undefined,
): ApplicationStatusFacets => {
  if (
    !applicationFacetsData ||
    applicationFacetsData.applicationsFacets.__typename !==
      'ApplicationsFacetsResponseSuccess'
  ) {
    return {
      inboxCount: null,
      prescreenCount: null,
      shortlistCount: null,
      interviewCount: null,
      offerCount: null,
      acceptCount: null,
      rejectedCount: null,
      newCount: null,
      totalCount: null,
    };
  }
  return applicationFacetsData.applicationsFacets.result.statusFacets;
};
